import MypageEditProfileContainer from './MypageEditProfileContainer';
export default MypageEditProfileContainer;
